import { HEROES } from '@fukemon/shared';
import { useGameStore } from '../state/gameStore';
import { Icon } from './Icon';
import { WalletButton } from './WalletButton';

export function TopBar() {
  const heroId = useGameStore((state) => state.selectedHero);
  const soundOn = useGameStore((state) => state.soundOn);
  const setSoundOn = useGameStore((state) => state.setSoundOn);
  const setPanel = useGameStore((state) => state.setPanel);
  const hero = HEROES.find((item) => item.id === heroId)!;

  return (
    <header className="topbar">
      <div className="brand-lockup">
        <span>FUKÉMON</span>
        <strong>MARKET MAYHEM</strong>
      </div>
      <div className="player-chip">
        <span className="player-chip__orb" style={{ background: hero.color }} />
        <div>
          <small>ACTIVE DISASTER</small>
          <strong>{hero.name}</strong>
        </div>
      </div>
      <div className="topbar__actions">
        <button
          className="icon-button"
          aria-label={soundOn ? 'Mute sound' : 'Enable sound'}
          onClick={() => setSoundOn(!soundOn)}
        >
          <Icon name={soundOn ? 'volume' : 'muted'} size={18} />
        </button>
        <button
          className="icon-button"
          aria-label="Open settings"
          onClick={() => setPanel('settings')}
        >
          <Icon name="settings" size={18} />
        </button>
        <WalletButton />
      </div>
    </header>
  );
}

